<template>
  <div class="sub-header__container">
    <h1
      v-html="'Olá <strong>' + currentUser.name + '</strong>'"
      class="sub-header__title"
    />
    <small
      class="sub-header__subtitle"
      v-text="dateNow"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment/moment'
import 'moment/locale/pt-br'
moment.locale('pt-br')

export default {
  name: 'MainHeader',
  computed: {
    ...mapGetters(
      'authentication',
      [
        'isAuthenticated',
        'currentUser'
      ]
    ),
    dateNow: () => {
      return moment(new Date()).format('dddd, DD MMMM YYYY', 'pt-BR')
    }
  }
}
</script>
<style lang="stylus">
  .sub-header {
    &__container {
      position: fixed;
      top: 60px;
      padding: 0 0 0 24px;
    }
    &__title {
      font-size: 20px;
      font-weight: 300;
      margin-bottom: 0;
      line-height: 17px;
      color: #555;

      strong {
        font-weight: 700;
      }
    }
    &__subtitle {
      display: block;
      font-size: 10px;
      color: #999;
    }
  }
  @media screen and (min-width: 768px) {
    .sub-header {
      &__container {
        position: relative;
        top: auto;
      }
    }
  }
  @media screen and (min-width: 1280px) {
    .sub-header {
      &__container {
        left: 200px;
      }
    }
  }
</style>
